<template>
  <div class="ui-toolbar">
    <div class="ui-toolbar--left">
      <div
        v-if="showNavIcon"
        class="ui-toolbar__icon"
        @click.stop="navIconClick"
      >
        <slot name="nav-icon" />
      </div>
      <div v-if="showTitle" class="ui-toolbar__title">
        <slot name="title">
          <Transition name="title-fade">
            <div :key="title" class="ui-toolbar__title-text" v-text="title" />
          </Transition>
        </slot>
      </div>
    </div>
    <div class="ui-toolbar--center">
      <slot />
    </div>
    <div class="ui-toolbar--right">
      <slot name="actions" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    showNavIcon: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Title',
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    navIconClick() {
      this.$emit('navIconClicked');
    },
  },
};
</script>

<style lang="scss">
.title-fade-enter-active,
.title-fade-leave-active {
  transition: all 0.4s;
}

.title-fade-enter,
.title-fade-leave-active {
  opacity: 0;
}

.title-fade-enter {
  transform: translateX(-40px);

  @include rtl() {
    transform: translateX(40px);
  }
}

.title-fade-leave-active {
  transform: translateX(40px);

  @include rtl() {
    transform: translateX(-40px);
  }
}

.ui-toolbar {
  /* Positioning */
  position: fixed;
  z-index: $lb-navbar-z-index;
  top: 0;
  left: 0;
  right: 0;
  padding-left: $global-padding;
  padding-right: $global-padding;

  /* Box Model */
  height: $lb-navbar-height;
  display: flex;

  /* Typography */
  align-items: center;
  font-size: 18px;
  color: #fff;

  /* Visual */
  background-color: $lb-color-primary;

  &--left {
    /* Box Model */
    display: flex;
    flex-shrink: 0;

    /* Typography */
    align-items: center;
  }

  &--center {
    /* Box Model */
    display: flex;
    flex-grow: 1;
    justify-content: flex-end;
    align-items: center;
  }

  &--right {
    /* Box Model */
    flex-shrink: 0;

    [slot='actions'] {
      /* Box Model */
      display: flex;
    }
  }

  &__title {
    /* Box Model */
    padding-left: map_get($grid-column-gutter, medium) / 2;
    padding-right: map_get($grid-column-gutter, medium) / 2;
    position: relative;
    min-height: 27px;
    white-space: nowrap;

    &-text {
      /* Box Model */
      flex-grow: 1;
      position: absolute;
    }
  }

  &__icon {
    i {
      line-height: inherit;
    }

    &:hover {
      cursor: pointer;
    }
  }

  &__links {
    display: flex;
    align-items: center;
  }
  // To raise specificity for NavBar DropDown Menu
  & &__link {
    display: inline-flex;
    color: #fff;
    padding: 0;
    margin-left: $global-margin * 2;
    margin-right: 0;
    font-size: $lb-navbar-nav-font-size;
    cursor: pointer;

    :focus {
      outline: none;
    }

    @include rtl() {
      margin-left: 0;
      margin-right: $global-margin * 2;
    }

    &:hover {
      color: #fff;
    }

    &--latin {
      text-transform: capitalize;
    }

    &:last-child {
      margin-right: $global-margin;

      @include rtl() {
        margin-left: $global-margin;
      }
    }
  }

  &--shadowed {
    /* Visual */
    box-shadow: $lb-navbar-box-shadow;
  }

  @include breakpoint(large) {
    position: static;
    box-shadow: none;
  }
}
</style>
